import { Model as ORMModel, attr, fk } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'
import { ProductionMachine } from 'stateMachines/production'
export default class Model extends ORMModel {
  static get fields() {
    return {
      id: attr(),

      name: attr({ getDefault: () => '' }),
      desc: attr({ getDefault: () => '' }),
      image: attr({ getDefault: () => '' }),

      color: attr({ getDefault: () => '' }),
      backgroundColor: attr({ getDefault: () => '' }),

      balance: attr({ getDefault: () => 0 }),
      company: attr({ getDefault: () => '' }),
      directorId: fk({
        to: 'Wrestler',
        as: 'director',
        relatedName: 'BrandDirector'
      })
    }
  }
  static reducer(action, Brand, session) {
    let item
    switch (action.type) {
      default:
        break
      case Types.RESET:
      case Types.RESET_BRANDS:
        session.Brand.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.GENERATE_BRANDS:
        action?.payload?.forEach(newItem => {
          session.Brand.upsert(newItem)
        })
        break
      case Types.ADD_BRAND:
        const id = action?.payload?.id || getId()
        Brand.upsert({ id, ...action.payload })
        break
      case Types.UPDATE_BRAND:
        item = Brand.withId(action.payload.id)
        item.update(action.payload)
        break
      case Types.DELETE_BRAND:
        Brand.withId(action.payload.id).delete()
        break
      case Types.PRODUCTION_COMPLETE_BRANDS:
        if (action?.payload?.brandIds) {
          const values = new ProductionMachine(action.payload)
            .calculate()
            .applyPayouts()
            .getState()
          values?.brands?.forEach(brand => {
            const updatedBrand = session.Brand.withId(brand.id)
            if (updatedBrand) {
              updatedBrand.update({ balance: brand.balance })
            }
          })
        }
        break
    }
  }
}
